const handlers = {
  "doctor-approval-request": function (data) {
    if (data.is_accepted == 0) {
      return;
    }
    return {
      name: "ShowConsultant",
      params: { id: data.id },
    };
  },
  "new-doctor-treatmentPlan": function (data) {
    return {
      name: "ShowCourse",
      params: { id: data.period_id },
      query: { tab: 3 },
    };
  },
  "new-ticket": function (data) {
    return {
      name: "ShowCourse",
      params: { id: data.period_id },
      query: { tab: 2 },
    };
  },
  "daily-chore": function (data) {
    return {
      name: "ShowCourse",
      params: { id: data.id },
    };
  },
};

export default handlers;
